// extracted by mini-css-extract-plugin
export default {"crossError":"crossError_crossError__I-DD-"};